module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("… and those who fear life are already three parts dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1-2"
  }, [_c('span', [_vm._v("—Bertrand Russell")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("… and I guess it isn’t too important now that they all die. I will be satisfied to make them three parts dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1-2"
  }, [_c('span', [_vm._v("—Mack Bolan, THE EXECUTIONER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0